export default "__VITE_ASSET__M4K0mFEP__"